var _defs, _path, _path2, _path3, _path4, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyes1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    "data-name": "Layer 3",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 354.36 89.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #3d3327;\n      }\n      .cls-2 {\n        fill: #fff;\n      }\n      .accent {\n        fill: #0073b3;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M567.39,323.11s-29,41.44-64.79,41.44-64.79-41.44-64.79-41.44,29-41.43,64.79-41.43S567.39,323.11,567.39,323.11Z",
    transform: "translate(-213.03 -279.68)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M567.39,327.89s-29,41.43-64.79,41.43-64.79-41.43-64.79-41.43,29-41.43,64.79-41.43S567.39,327.89,567.39,327.89Z",
    transform: "translate(-213.03 -279.68)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M342.61,321.11s-29,41.44-64.79,41.44S213,321.11,213,321.11s29-41.43,64.79-41.43S342.61,321.11,342.61,321.11Z",
    transform: "translate(-213.03 -279.68)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M342.61,326.13s-29,41.43-64.79,41.43S213,326.13,213,326.13s29-41.43,64.79-41.43S342.61,326.13,342.61,326.13Z",
    transform: "translate(-213.03 -279.68)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "accent",
    cx: 283.96,
    cy: 48.21,
    r: 28.21
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "accent",
    cx: 71.28,
    cy: 46.44,
    r: 28.21
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyes1);
export default __webpack_public_path__ + "static/media/eyes1.18e622ef.svg";
export { ForwardRef as ReactComponent };